import React, { Component } from 'react';
import { isEmpty, getModeIcon } from '../../Common/Common';
import Switch from '../../Part_Sample/Switch';
import Select from '../../Part_Sample/Select';
import Editbox from '../../Part_Sample/Editbox';
import Button from '../../Part_Sample/Button';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Display_Actions from '../../Display_Actions/Display_Actions';
import Display_Conditions from './Components/Display_Conditions';

export default class Interlock_Summary extends Component {
	constructor(props) {
		super(props);
		this.program = {};

		this.lastClickTime = false;

		if (this.props.param.program != null) {
			this.program = this.props.param.program
		} else if (this.props.param.interlock.program[this.props.param.program_id] != null) {
			this.program = this.props.param.interlock.program[this.props.param.program_id];
		} else {
			// Set default to 'all'
			this.program.exec_condition = 'all';
		}

		let interlock_name = '';
		let exec = false;
		let num = 0;
		let duration = 0;

		if (this.program.name != null) interlock_name = this.program.name;
		if (this.program.exec != null) exec = this.program.exec;
		if (this.program.duration != null) duration = this.program.duration;

		if (isEmpty(this.program.action)) this.program.action = [];
		if (isEmpty(this.program.condition)) this.program.condition = [];

		let op_type = 'input';
		if (this.props.param.op_type != null) op_type = this.props.param.op_type;

		this.state = {
			op_type: op_type,
			interlock_name: interlock_name,
			exec: exec,
		}
	}

	preventMultipleTaps = () => {
		if (this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		let paramTemp = JSON.parse(JSON.stringify(this.props.param));

		if(paramTemp.hasOwnProperty('original_param')) {
			paramTemp = JSON.parse(JSON.stringify(paramTemp.original_param));
		}

		this.props.content_handler('Interlock', paramTemp);
	}

	handleShowOps = (command) => {
		this.setState({
			op_type: command
		})
	}

	handleToggleEnable = () => {
		this.setState({ exec: !this.state.exec })
	}

	handleChangeInterlockName = (val) => {
		this.setState({ interlock_name: val })
	}

	handleEditInput = () => {
		this.program.name = this.state.interlock_name;
		this.program.exec = this.state.exec;
		let param = JSON.parse(JSON.stringify(this.props.param));
		param.program = this.program;

		//store first instance of condition
		param.program.original_condition = param.program.condition;

		this.props.content_handler('Edit_Interlock_Input', param)
	}

	handleAddOutputAction = () => {
		this.program.name = this.state.interlock_name;
		this.program.exec = this.state.exec;

		let originalParam = {};

		if(!this.props.param.hasOwnProperty('original_param')) {
			originalParam = JSON.parse(JSON.stringify(this.props.param));
		} else {
			originalParam = JSON.parse(JSON.stringify(this.props.param.original_param));
		}

		this.props.content_handler('Add_Edit_Output_Action', { op_type: 'output', action_index: null, program: this.program, program_id: this.props.param.program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups, original_param: originalParam });
	}

	handleEditOutputAction = (action_index) => {
		this.program.name = this.state.interlock_name;
		this.program.exec = this.state.exec;

		let originalParam = {};

		if(!this.props.param.hasOwnProperty('original_param')) {
			originalParam = JSON.parse(JSON.stringify(this.props.param));
		} else {
			originalParam = JSON.parse(JSON.stringify(this.props.param.original_param));
		}

		this.props.content_handler('Add_Edit_Output_Action', { op_type: 'output', action_index: action_index, program: this.program, program_id: this.props.param.program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups, original_param: originalParam });
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		if (this.state.interlock_name == '') {
			window.app.hideLoading();
			this.lastClickTime = false;

			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		// Tommy - 21/09/21
		let interlock_conditions = this.program.condition;

		for (let position in interlock_conditions) {
			if (Object.keys(interlock_conditions[position]).length == 0) interlock_conditions.splice(position, 1);
		}

		// Tommy - 21/09/21 - If no condition or no action, cannot be saved
		if (interlock_conditions.length == 0 || this.program.action.length == 0) {
			window.app.hideLoading();
			this.lastClickTime = false;

			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
			return;
		}

		this.program.name = this.state.interlock_name;
		this.program.exec = this.state.exec;

		if (this.props.param.program_id == null) {
			this.props.receiver.addInterlockProgram(this.program);
		} else {
			let program = {};
			program[this.props.param.program_id] = this.program;
			this.props.receiver.modifyInterlockProgram(program);
		}
	}

	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		this.props.receiver.deleteInterlockProgram(this.props.param.program_id);
	}

	rcvAddInterlockProgram(response) {
		if (response.result != 'NG') {
			this.props.receiver.next_component = 'Interlock';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyInterlockProgram(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Interlock';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteInterlockProgram(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Interlock';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let max_height = this.props.height - 245;
		if (max_height < 200) max_height = 200;

		let exec_condition = '';

		if (this.program.exec_condition != null) {
			if (this.program.exec_condition == 'all') exec_condition = this.props.receiver.getString('allInputsValid');
			else if (this.program.exec_condition == 'one') exec_condition = this.props.receiver.getString('atLeastOneInputValid');
			else if (this.program.exec_condition == 'none') exec_condition = this.props.receiver.getString('allInputsInvalid');
			else exec_condition = this.props.receiver.getString('num');
		}

		let is_show_conditions = false;

		//Tommy - 21/09/21 - Should not show condition when the point doesnt exist
		let mp = "";
		for (let position in this.program.condition) {
			let interlock_condition = this.program.condition[position];
			if (interlock_condition.hasOwnProperty('mp')) {
				mp = interlock_condition.mp;
				if (!window.app.state.point_list.hasOwnProperty(mp)) this.program.condition.splice(position, 1);
			}
		}

		if (this.program.condition != null) {
			if (!isEmpty(this.program.condition[0])) is_show_conditions = true;
		}

		//Alex - 12/10/21 - Added action check to see if ID exist in Device list/Schedule/Scenes/Interlock/Group, same as Tommy above
		let available_functions = this.props.receiver.active_controller.available_functions;

		for (let i in this.program.action) {
			let interlock_action = this.program.action[i];

			if (!isEmpty(interlock_action[0])) {
				let existAsDevice = false;
				let existAsSchedule = false;
				let existAsScene = false;
				let existAsInterlock = false;
				let existAsGroup = false;

				if (window.app.state.point_list.hasOwnProperty(interlock_action[0])) existAsDevice = true;
				
				if(available_functions.schedule) {
					if(this.props.param.schedule.hasOwnProperty('program')) {
						if (this.props.param.schedule.program.hasOwnProperty(interlock_action[0])) existAsSchedule = true;
					}
				}

				if(available_functions.scene) {
					if (this.props.param.scenes.hasOwnProperty(interlock_action[0])) existAsScene = true;
				}

				if(available_functions.interlock) {
					if(this.props.param.interlock.hasOwnProperty('program')) {
						if (this.props.param.interlock.program.hasOwnProperty(interlock_action[0])) existAsInterlock = true;
					}
				}

				if(available_functions.group) {
					if (this.props.param.groups.hasOwnProperty(interlock_action[0])) existAsGroup = true;
				}

				if (!existAsDevice && !existAsSchedule && !existAsScene && !existAsInterlock && !existAsGroup) {
					this.program.action.splice(i, 1);
				}
			} else {
				this.program.action.splice(i, 1);
			}
		}

		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('interlock_summary')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div id="scrollable-content" style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>

						<div>
							<div style={{ display: 'inline-block', width: this.props.width - 100, marginLeft: 10 }}>
								<Editbox id='interlock_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeInterlockName(event.target.value)} value={this.state.interlock_name} />
							</div>
							<div style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.exec} handleToggleSwitch={this.handleToggleEnable} />
							</div>
						</div>
						<div style={{ marginTop: 20, verticalAlign: 'bottom', width: '100%', opacity: 0.95 }}>
							<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.op_type == 'input' ? this.props.colours.midnight_sky : 'white', color: this.state.op_type == 'input' ? 'white' : 'black' }} onClick={() => this.handleShowOps('input')}>{this.props.receiver.getString('condition')}</span>
							<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.op_type == 'output' ? this.props.colours.midnight_sky : 'white', color: this.state.op_type == 'output' ? 'white' : 'black' }} onClick={() => this.handleShowOps('output')}>{this.props.receiver.getString('controls')}</span>
						</div>
						{(() => {
							switch (this.state.op_type) {
								case 'input':
									return (
										<div className='noScrollBar' style={{ cursor: 'pointer', width: '100%', overflow: "auto", height: is_landscape ? 'auto' : max_height, paddingBottom: is_landscape ? 60 : 0 }} onClick={this.handleEditInput}>
											<div style={{ display: this.program.exec_condition != null ? 'block' : 'none', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 20, textAlign: 'left' }}>
												<div style={{ width: this.props.width - 40 }}>
													<span className='title'>{this.props.receiver.getString('exec_condition') + ': '}</span>
												</div>
												<div style={{ width: this.props.width - 40, marginLeft: 20 }}>
													<span >{exec_condition}</span>
												</div>
											</div>
											{/* Hide content if program duration is NaN */}
											<div style={{ display: this.program.duration != null && Number.isNaN(this.program.duration) == false ? 'block' : 'none', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 20, textAlign: 'left' }}>
												<div style={{ width: this.props.width - 40 }}>
													<span className='title'>{this.props.receiver.getString('timer') + ': '}</span>
												</div>
												<div style={{ width: this.props.width - 40, marginLeft: 20 }}>
													<span >{this.program.duration}</span>
												</div>
											</div>
											<div style={{ display: is_show_conditions ? 'block' : 'none', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 20, textAlign: 'left' }}>
												<div style={{ width: this.props.width - 40 }}>
													<span className='title'>{this.props.receiver.getString('condition') + ': '}</span>
												</div>
												<div style={{ width: this.props.width - 40, boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)' }}>
													<Display_Conditions
														program={this.program}
														width={this.props.width}
														height={this.props.height}
														receiver={this.props.receiver}
														handleEditInputCondition={null}
													/>
												</div>
											</div>
											<div id='add_target' style={{ width: '100%', minWidth: 30, verticalAlign: 'top', marginTop: 20, textAlign: 'center', cursor: 'pointer' }}>
												<span className='footnote'>{this.props.receiver.getString('edit_interlock_input_instr')}</span>
											</div>
										</div>
									);
									break;
								case 'output':
									return (
										<div className='noScrollBar' style={{ width: '100%', overflow: "auto", height: is_landscape ? 'auto' : max_height, paddingBottom: is_landscape ? 60 : 0 }}>
											<div style={{ textAlign: 'left', marginLeft: 20, marginTop: 20 }}>
												<div style={{ marginTop: 20 }}>
													{this.program.action.map((action, action_index) => {
														let id = action[0];
														let name = '';
														if (!isEmpty(window.app.state.point_list[id])) {
															name = window.app.state.point_list[id].name;
														} else if (!isEmpty(this.props.param.groups[id])) {
															name = this.props.param.groups[id].name;
														} else if (!isEmpty(this.props.param.scenes[id])) {
															name = this.props.param.scenes[id].name;
														} else if (!isEmpty(this.props.param.schedule.program[id])) {
															name = this.props.param.schedule.program[id].name;
														} else if (!isEmpty(this.props.param.interlock.program[id])) {
															name = this.props.param.interlock.program[id].name;
														}

														let action_details = action[1];
														// If action's id can be found
														// Adjust the width % and background color
														if (name != '') {
															return (
																<div style={{ cursor: 'pointer', backgroundColor: '#f1f1f1', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10, width: this.props.width - 40, minHeight: 50, marginTop: 10 }} onClick={() => this.handleEditOutputAction(action_index)}>
																	<div style={{ display: 'inline-block', width: '50%' }}>
																		<div style={{ paddingLeft: 10 }}>
																			<span>{name}</span>
																		</div>
																	</div>
																	<Display_Actions style={{ width: '50%', textAlign: 'right' }} point_info={null} actions={action_details} receiver={this.props.receiver} />
																</div>
															)
														} else {
															return null;
														}
													})}
												</div>
												<div id='add_output_action' onClick={this.handleAddOutputAction} style={{ marginTop: 20, padding: 5, width: this.props.width - 80, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', textAlign: 'center', cursor: 'pointer', border: '1px solid ' + this.props.colours.appBlue }}>
													<span className='footnote'>{this.props.receiver.getString('add_output')}</span>
												</div>
											</div>
										</div>
									);
									break;
								default:
									return (
										<div>

										</div>
									);
							}
						})()}

					</div>
				</div>
			</div>
		)
	}
}